import React from 'react';
import ReactDOM from 'react-dom/client';
import App from '../src/main-component/App/App';
import 'bootstrap/dist/css/bootstrap.min.css';
import './css/fontawesome.css';
import './css/themify-icons.css';
import './css/animate.css';
import './css/cursor.css';
import './css/custom-font.css';
import './css/main.css';
import './index.css';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
    <App />
);
